import React from "react";
import { Img } from "src/app/components/Img/Img";
import avatarPlaceholder from "src/images/avatar-purple.svg";

import "./AuthorCell.scss";
import LazyLoad from "react-lazy-load";

export function AuthorCell({ name, avatarUrl }) {
  return (
    <div className="influencers-list__cell influencers-list__cell--author">
      <div className="influencers-list__cell--author__avatar-wrapper">
        <LazyLoad>
          <Img
            className="influencers-list__cell--author__avatar"
            src={avatarUrl}
            alt="avatar"
            fallbackImageSrc={avatarPlaceholder}
            loading="lazy"
          />
        </LazyLoad>
      </div>
      <div className="influencers-list__cell--author__name">{name}</div>
    </div>
  );
}
